import withDddDetail from "../withDddDetail";
import DddDisinsectionForm from "./DddDisinsectionForm";
import DddDisinsectionPDFGenerator from "./DddDisinsectionPDFGenerator";

const dddFormKazakhName = 'Дезинфекцияға, дератизацияға берілетін НАРЯД'
const dddFormName = 'НАРЯД на дезинcекцию, дератизацию'
const dddName = 'DddDisinsection'

export default withDddDetail(DddDisinsectionForm, DddDisinsectionPDFGenerator, dddFormKazakhName, dddFormName, dddName)
